<!-- START TOPBAR -->
<div class="page-topbar sidebar_shift">
  <!-- START LOGO AREA -->
  <div class="logo-area">
  </div>
  <!-- END LOGO AREA -->
  <!-- START USER MENU -->
  <div class="user-area">

    <div class="pull-right">
      <ul class="info-menu left-lin list-inline list-unstyled">
        <li class="profile showopacity">
          <a href="#" data-toggle="dropdown" class="toggle">
            <img src="/Images/profile-example-2.png" alt="user-image" class="img-circle img-inline">
            <span>{{userName}} <i class="fa fa-angle-down"></i></span>
          </a>
          <ul class="dropdown-menu profile">
            <li>
              <a routerLink="change-password">
                <i class="fa fa-key"></i>
                Change password
              </a>
            </li>
            <li>
              <a (click)="changeSource()">
                <i class="fa fa-info"></i>
                Change location
              </a>
            </li>
            <!--<li>
              <a (click)="getApk()">
                <i class="fa fa-info"></i>
                Install Android app
              </a>
            </li>-->
            <li class="last">
              <a (click)="logout()">
                <i class="fa fa-lock"></i>
                Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <!-- END USER MENU -->
</div>

<!-- END TOPBAR -->
<!-- START CONTAINER -->
<div class="page-container row-fluid container-fluid fixed">



  <!-- SIDEBAR - START -->
  <div class="page-sidebar collapseit">
    <!-- MAIN MENU - START -->
    <div class="page-sidebar-wrapper" id="main-menu-wrapper">


      <ul class="wraplist">
        <li class="menusection">Dashboard</li>
        @if(userCanRequest) {
        <li class="">
          <a routerLink="request">
            <i class="fa fa-check-square-o"></i>
            <span class="title">New Request</span>
          </a>
        </li>
        <li class="">
          <a routerLink="request-list">
            <i class="fa fa-sort-amount-asc"></i>
            <span class="title">Request Lists</span>
          </a>
        </li>
        }
        @if(userCanViewResults) {
          <li class="">
            <a routerLink="result-list">
              <i class="fa fa-line-chart"></i>
              <span class="title">Results Lists</span>
            </a>
          </li>
        }

      </ul>

    </div>
    <!-- MAIN MENU - END -->

  </div>
  <!--  SIDEBAR - END -->
  <router-outlet></router-outlet>
</div>

<!-- END CONTAINER -->
